import { ChipsideComponent } from "../chipside-component";

export class Radio extends ChipsideComponent {
	static observedAttributes = ["checked", "value"];
	#Mappers = {};

	constructor() {
		super();

		this.identifier = this.getAttribute("identifier") ?? crypto.randomUUID().slice(0, 8);
		this.label = this.getAttribute("label");
		this.checked = this.hasAttribute("checked");
		this.helperText = this.getAttribute("helper-text") ?? "";
		this.value = this.getAttribute("value") ?? "true";

		this.#Mappers = {
			name: this.getAttribute("name")
		};

		if (this.closest("form") && !this.#Mappers.name) { this.#Mappers.name = this.id ?? this.identifier; }
	}

	parsedCallback() {
		this.classList.add("checkbox__wrapper");

		const radio = document.createElementWithContents("input", null, {
			id: this.identifier,
			className: "input-field",
			type: "radio",
			checked: this.checked,
			value: this.value
		});

		radio.addEventListener("change", () => this.checked = radio.checked);

		Object.keys(this.#Mappers).filter(x => this.#Mappers[x])
			.forEach(key => radio.setAttribute(key, this.#Mappers[key] === true ? "" : this.#Mappers[key]));

		if (this.helperText) {
			this.prepend(document.createElementWithContents("div", this.helperText, {
				className: "input-field__helper-text"
			}));
		}

		if (this.label) { this.prepend(document.createElementWithContents("label", this.label, { htmlFor: this.identifier })); }

		this.prepend(radio);
	}

	focus() {
		this.querySelector("input")?.focus();
	}

	attributeChanged(name, _, newValue) {
		if (name === "checked") {
			this.querySelector("input").checked = this.IsAttributeValueTrue(newValue);
		}
	}
}